"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRACK_BRINGG_USER_ONLINE_STATUS_QUEUE_NAME = exports.TrackBringgUserStatusQueueEventTypes = void 0;
var TrackBringgUserStatusQueueEventTypes;
(function (TrackBringgUserStatusQueueEventTypes) {
    TrackBringgUserStatusQueueEventTypes["SetOnline"] = "SET_ONLINE";
    TrackBringgUserStatusQueueEventTypes["SetOffline"] = "SET_OFFLINE";
})(TrackBringgUserStatusQueueEventTypes || (exports.TrackBringgUserStatusQueueEventTypes = TrackBringgUserStatusQueueEventTypes = {}));
exports.TRACK_BRINGG_USER_ONLINE_STATUS_QUEUE_NAME = 'chat-service-track-bringg-user-online-status-queue';
//# sourceMappingURL=event_bus_types.js.map